export default __webpack_public_path__ + "static/media/DSC03673.abe05c8b.jpg";